namespace TabAurous.ECommerce {
    export interface ECommSalesReportRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        RefVoucherId?: number;
        DeppartmentId?: number;
        PartyId?: number;
        POSCustomerId?: number;
        BaseItemTypeId?: number;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        Roundoff?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        Remark?: string;
        CompanyId?: number;
        CompanyName?: string;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        AddressId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        FinancialYearId?: number;
        UserId?: number;
        GrossAmountSlot1?: number;
        GrossAmountSlot2?: number;
        GrossAmountSlot3?: number;
        GrossAmountSlot4?: number;
        GrossAmountSlot5?: number;
        GrossAmountSlot6?: number;
        GrossAmountDay1?: number;
        GrossAmountDay2?: number;
        GrossAmountDay3?: number;
        GrossAmountDay4?: number;
        GrossAmountDay5?: number;
        GrossAmountDay6?: number;
        TotalGrossAmount?: number;
    }

    export namespace ECommSalesReportRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'ECommerce.ECommSalesReport';
        export const deletePermission = 'EComm:ECommSales:Delete';
        export const insertPermission = 'EComm:ECommSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommSales:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            RefVoucherId = "RefVoucherId",
            DeppartmentId = "DeppartmentId",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            BaseItemTypeId = "BaseItemTypeId",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            Roundoff = "Roundoff",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            Remark = "Remark",
            CompanyId = "CompanyId",
            CompanyName = "CompanyName",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            AddressId = "AddressId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            GrossAmountSlot1 = "GrossAmountSlot1",
            GrossAmountSlot2 = "GrossAmountSlot2",
            GrossAmountSlot3 = "GrossAmountSlot3",
            GrossAmountSlot4 = "GrossAmountSlot4",
            GrossAmountSlot5 = "GrossAmountSlot5",
            GrossAmountSlot6 = "GrossAmountSlot6",
            GrossAmountDay1 = "GrossAmountDay1",
            GrossAmountDay2 = "GrossAmountDay2",
            GrossAmountDay3 = "GrossAmountDay3",
            GrossAmountDay4 = "GrossAmountDay4",
            GrossAmountDay5 = "GrossAmountDay5",
            GrossAmountDay6 = "GrossAmountDay6",
            TotalGrossAmount = "TotalGrossAmount"
        }
    }
}
